const LOCATION_FRAGMENT = `
fragment location on Location {
  id
  code
  description
  locationType
  totalValue
  isDefault
  cycleCountDue
  cycleCountStartDate
  cycleCountFrequencyDays
  nextCycleCountDate
  createdAt
  updatedAt
  latestCycleCount {
    id
    status
    completedAt
    countedAt
  }
  user {
    id
    name
  }
}
`

export const LOCATIONS_QUERY = `
query Locations($accountId: Int!, $branchId: Int) {
  locations(accountId: $accountId, branchId: $branchId) {
    ...location
  }
}
${LOCATION_FRAGMENT}
`

export const LOCATION_QUERY = `
query Location($id: Int!) {
  location(id: $id) {
    ...location
    branches {
      id
      name
    }
  }
}
${LOCATION_FRAGMENT}
`

export const CREATE_LOCATION_MUTATION = `
mutation LocationCreate($attributes: LocationCreateAttributes!) {
  locationCreate(attributes: $attributes) {
    result {
      ...location
    }
    errors
  }
}
${LOCATION_FRAGMENT}
`

export const UPDATE_LOCATION_MUTATION = `
mutation LocationUpdate($id: Int!, $attributes: LocationUpdateAttributes!) {
  locationUpdate(id: $id, attributes: $attributes) {
    result {
      ...location
    }
    errors
  }
}
${LOCATION_FRAGMENT}
`

export const DELETE_LOCATION_MUTATION = `
mutation LocationDelete($id: Int!) {
  locationDelete(id: $id) {
    result
    errors
  }
}
`

export const LOCATION_WITH_ITEMS_QUERY = `
query LocationWithItems($id: Int!, $branchId: Int) {
  location(id: $id) {
    id
    code
    locationType
    totalValue
    hasCycleCounts
    branches { id name }
    locationItems {
      id
      unit
      price
      inventory
      threshold
      branchProductThreshold(branchId: $branchId)
      product {
        id
        name
        code
        photo
        stockState
        stockInventory
        erpCatalogName
      }
    }
  }
}
`

const INVENTORY_PRODUCT_FIELDS = `
fragment inventoryProductFields on InventoryProduct {
  id
  price
  priceVisible
  unit
  inventory
  threshold
  notifyThreshold
  quantity
  product {
    id
    code
    name
    description
    photo
    erpCatalogName
  }
}
`

export const BRANCH_INVENTORY_PRODUCTS_SEARCH_QUERY = `
${INVENTORY_PRODUCT_FIELDS}
query BranchInventoryProducts($branchId: Int!, $term: String) {
  manager {
    currentBranch: branches(id: $branchId) {
      inventoryProducts(term: $term) {
        ...inventoryProductFields
      }
    }
  }
}
`

export const INTERNAL_BRANCH_INVENTORY_PRODUCTS_SEARCH_QUERY = `
${INVENTORY_PRODUCT_FIELDS}
query BranchInventoryProductsInternal($accountId: Int!, $branchId: Int!, $term: String) {
  internal {
    accounts(id: $accountId) {
      nodes {
        currentBranch: branches(id: $branchId) {
          inventoryProducts(term: $term) {
            ...inventoryProductFields
          }
        }
      }
    }
  }
}
`

export const CREATE_LOCATION_ITEM_MUTATION = `
mutation LocationItemCreate($attributes: LocationItemCreateAttributes!) {
  locationItemCreate(attributes: $attributes) {
    result {
      id
      unit
      price
      inventory
      threshold
      product {
        id
        name
        code
        photo
        stockState
        stockInventory
        erpCatalogName
      }
    }
    errors
  }
}
`

export const DELETE_LOCATION_ITEM_MUTATION = `
mutation LocationItemDelete($id: ID!) {
  locationItemDelete(id: $id) {
    result {
      id
    }
    errors
  }
}
`

export const UPDATE_LOCATION_ITEM_MUTATION = `
mutation LocationItemUpdate($id: Int!, $attributes: LocationItemUpdateAttributes!) {
  locationItemUpdate(id: $id, attributes: $attributes) {
    result {
      id
      threshold
      inventory
      price
      unit
    }
    errors
  }
}
`

export const INTERNAL_LOCATION_ASSIGNABLE_USERS_QUERY = `
query LocationAssignableUsers($branchId: Int!, $accountId: Int) {
  internal {
    accounts(id: $accountId) {
      nodes {
        id
        branches(id: $branchId) {
          id
          locationAssignableUsers {
            id
            name
          }
        }
      }
    }
  }
}
`

export const MANAGER_LOCATION_ASSIGNABLE_USERS_QUERY = `
query LocationAssignableUsers($branchId: Int!) {
  manager {
    currentBranch: branches(id: $branchId) {
      id
      locationAssignableUsers {
        id
        name
      }
    }
  }
}
`

export const UPLOAD_LOCATIONS_QUERY = `
mutation UploadLocations($accountId: String!, $branchId: String!) {
  loadLocationsCsv(accountId: $accountId, branchId: $branchId) {
    locations: result {
      ...location
    }
    errors
  }
}
${LOCATION_FRAGMENT}
`

export const EXPORT_LOCATIONS_QUERY = `
query ExportLocations($accountId: Int!, $branchId: Int) {
  locationsCsv(accountId: $accountId, branchId: $branchId)
}
`
